<template>
  <v-card elevation="0">
    <v-list two-line v-if="!$vuetify.breakpoint.smAndUp">
      <v-list-item class="mt-n6 mx-n4">
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold primary--text"
            >Cliente</v-list-item-title
          >
          <v-list-item-subtitle class="font-weight-bold">
            {{
              `${infoCliente(`Nombre`, 1)} (${infoCliente(`Codigo`, 1)})`
            }}</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>
      <v-list-item class="mt-n6 mx-n4" v-if="infoCliente(`AliasCli`, 0)!==''">
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold primary--text"
            >Alias</v-list-item-title
          >
          <v-list-item-subtitle class="font-weight-bold">
            {{
              `${infoCliente(`AliasCli`, 0)}`
            }}</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>
      <v-list-item class="mt-n3 mx-n4">
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold primary--text"
            >Condicion de Pago</v-list-item-title
          >
          <v-list-item-subtitle class="font-weight-bold">
            {{ infoCliente(`CondicPago`, 0) }}</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>
      <v-list-item class="mt-n3 mx-n4">
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold primary--text"
            >Vendedor</v-list-item-title
          >
          <v-list-item-subtitle class="font-weight-bold">
            {{ infoCliente(`NombreVen`, 0) }}</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-if="infoCliente(`Descuento`, 1) !== 0" class="mt-n3 mx-n4">
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold primary--text"
            >Descuento</v-list-item-title
          >
          <v-list-item-subtitle class="font-weight-bold">
            {{ `${infoCliente(`Descuento`, 1)} %` }}</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-list-item three-line v-if="$vuetify.breakpoint.smAndUp" >
      <v-list-item-content>
        <v-list-item-title class="primary--text d-flex justify-space-between">
          <span>Cliente:</span>
          <span class="text-wrap font-weight-bold subtitle-1">
            {{
              `${infoCliente(`Nombre`, 1)} (${infoCliente(`Codigo`, 1)})`
            }}</span
          >
        </v-list-item-title>
        <v-list-item-subtitle
        v-if="infoCliente(`AliasCli`, 0)!==''"
          class="primary--text d-flex justify-space-between"
        >
          <span>Alias:</span>
          <span class="font-weight-bold subtitle-1">
            {{ infoCliente(`AliasCli`, 0) }}
 </span>
        </v-list-item-subtitle>
        <v-list-item-subtitle
          class="primary--text d-flex justify-space-between"
        >
          <span>Condicion de Pago:</span>
          <span class="font-weight-bold subtitle-1">
            {{ infoCliente(`CondicPago`, 0) }}
          </span>
        </v-list-item-subtitle>

        <v-list-item-subtitle
          class="primary--text d-flex justify-space-between"
        >
          <span>Vendedor:</span>
          <span class="text-wrap font-weight-bold subtitle-1">
            {{ infoCliente(`NombreVen`, 0) }}</span
          >
        </v-list-item-subtitle>
        <v-list-item-subtitle
          v-if="infoCliente(`Descuento`, 1) !== 0"
          class="primary--text d-flex justify-space-between"
        >
          <span>Descuento:</span>
          <span class="font-weight-bold subtitle-1">
            {{ `${infoCliente(`Descuento`, 1)} %` }}</span
          >
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-card>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
export default {
  components: {

  },
  data() {
    return {
      changeStatus: false,
      checkbox: true,
      select: new Date()
        .toLocaleString("sv", { timeZoneName: "short" })
        .substr(0, 4),
    };
  },
  methods: {
    ...mapActions(["get_DetalleCliente", "get_dsEstadistica"]),
    ...mapMutations(["set_GrupoCli"]),

    async estadisticas() {
      await this.get_dsEstadistica({
        opc: 4,
        anio: this.select,
        vergrupo:
          this.Cliente.data.GrupoCliente == 1 ? (this.checkbox ? 1 : 0) : 0,
      });
    },
    async Consolidado() {
      this.changeStatus = true;
      this.checkbox ? this.set_GrupoCli(1) : this.set_GrupoCli(0);
      await this.get_DetalleCliente();
      await this.estadisticas();
      this.changeStatus = false;
    },
  },
  computed: {
    ...mapState(["Cliente"]),
    infoCliente: function () {
      return function (idKey, idNodo) {
        let xInfo = [];
        const infoData = {
            0: `resumen`,
            1: `data`,
          },
          attrib = infoData[idNodo];

        if (Object.entries(this.Cliente[attrib]).length !== 0) {
          const { [idKey]: Codigo } = this.Cliente[attrib];
          const { [idKey]: Nombre } = this.Cliente[attrib];
          const { [idKey]: Descuento } = this.Cliente[attrib];
          const { [idKey]: CodigoVen } = this.Cliente[attrib];
          const { [idKey]: NombreVen } = this.Cliente[attrib];
          const { [idKey]: GrupoCliente } = this.Cliente[attrib];

          if (Codigo !== undefined) xInfo = Codigo;
          if (Nombre !== undefined) xInfo = Nombre;
          if (Descuento !== undefined) xInfo = Descuento;
          if (CodigoVen !== undefined) xInfo = CodigoVen;
          if (NombreVen !== undefined) xInfo = NombreVen;
          if (GrupoCliente !== undefined) xInfo = GrupoCliente;
        }
        return xInfo;
      };
    },
  },
};
</script>

<style></style>
